import { ApolloLink } from '@apollo/client';
import { tap } from 'rxjs';

import { systemUnavailableVar, verifyBackendAvailability } from './systemStatus';

// Sits below errorLink/authLink so it only ever sees raw transport-level
// results: a `next` means the backend responded at all (regardless of any
// GraphQL-level errors in the body), an `error` means the request failed at
// the transport level. Transport failures are not trusted directly — they
// trigger a /health probe (verifyBackendAvailability), and only a failed
// probe flips the system-unavailable screen.
const networkStatusLink = new ApolloLink((operation, forward) =>
  forward(operation).pipe(
    tap({
      next: () => systemUnavailableVar(false),
      error: (error) => {
        if (error instanceof DOMException && error.name === 'AbortError') return;
        verifyBackendAvailability();
      },
    }),
  ),
);

export default networkStatusLink;
